import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "sr-only" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "mr-auto min-w-0 flex-1 truncate whitespace-nowrap text-left" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  key: 0,
  class: "scrollbar-hide absolute left-0 top-full z-[2700] mt-2 max-h-60 min-w-[14rem] overflow-y-auto rounded-lg border border-concrete-300 bg-white py-1 shadow-xl"
}
const _hoisted_6 = ["onClick"]

import { computed, ref } from "vue";

import type { FacetCount } from "~/js/interfaces/facets";

import SvgLoader from "~/vue/atoms/svgs/SvgLoader.vue";

interface Props {
	label: string;
	loading: boolean;
	options: FacetCount[];
	selected: string;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FilterLocationCountry',
  props: {
    label: {},
    loading: { type: Boolean },
    options: {},
    selected: {},
    utilities: { default: "" }
  },
  emits: ["select"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const expanded = ref(false);

const selectedLabel = computed(() => {
	if (!props.selected) return props.label;
	const match = props.options.find((option) => option.highlighted === props.selected);
	return match?.value ?? props.label;
});

const toggle = () => {
	expanded.value = !expanded.value;
};

const onClose = () => {
	expanded.value = false;
};

const selectOption = (value: string) => {
	emit("select", value);
	expanded.value = false;
};

return (_ctx: any,_cache: any) => {
  const _directive_click_away = _resolveDirective("click-away")!

  return _withDirectives((_openBlock(), _createElementBlock("fieldset", {
    class: _normalizeClass(['relative shrink-0', expanded.value ? 'z-[2600]' : '', __props.utilities])
  }, [
    _createElementVNode("legend", _hoisted_1, _toDisplayString(__props.label), 1),
    _createElementVNode("button", {
      class: _normalizeClass([
				'inline-flex min-w-0 items-center px-4 py-2 print:hidden',
				'w-full rounded-full border border-concrete-500 bg-white',
				'font-primary text-sm text-black shadow-sm',
				'focus:outline-none focus:ring-4 focus:ring-celestial-500',
			]),
      type: "button",
      "aria-expanded": expanded.value,
      onClick: toggle
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(selectedLabel.value), 1),
      _createElementVNode("span", {
        class: _normalizeClass([
					'inline-flex shrink-0 transform-gpu items-center justify-end transition-transform duration-200 ease-in-out',
					expanded.value ? 'rotate-180' : 'rotate-0',
				])
      }, [
        (!__props.loading)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, [...(_cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "far fa-chevron-down" }, null, -1)
            ]))]))
          : _createCommentVNode("", true),
        _createElementVNode("span", {
          class: _normalizeClass([__props.loading ? 'block' : 'hidden', 'text-viridian-500'])
        }, [
          _createVNode(SvgLoader)
        ], 2)
      ], 2)
    ], 8, _hoisted_2),
    (expanded.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("button", {
            type: "button",
            class: "inline-flex w-full px-4 py-2 text-left font-primary text-sm text-black hover:bg-concrete-200",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectOption('')))
          }, _toDisplayString(__props.label), 1),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option) => {
            return (_openBlock(), _createElementBlock("button", {
              key: option.highlighted,
              type: "button",
              class: _normalizeClass([
					'inline-flex w-full px-4 py-2 text-left font-primary text-sm text-black',
					__props.selected === option.highlighted ? 'bg-concrete-200 font-semibold' : 'hover:bg-concrete-200',
				]),
              onClick: ($event: any) => (selectOption(option.highlighted))
            }, _toDisplayString(option.value), 11, _hoisted_6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ], 2)), [
    [_directive_click_away, onClose]
  ])
}
}

})